import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

interface LoginData {
  loginId: string;
  loginPw: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PgmLogin',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

// 대리 로그인 처리 중 상태
const isImpersonating = ref(false);

// 이미지 경로 설정
const logoImage = ref(new URL('../../../assets/images/hypehive-logo.png', import.meta.url).href);

// 반응형 데이터
const loginData = ref<LoginData>({
  loginId: '',
  loginPw: ''
});

const saveId = ref(false);
const loginForm = ref();
const isSubmitting = ref(false);

// 폼 유효성 검사 규칙
const rules = {
  required: (value: string) => !!value || '필수 입력 항목입니다.'
};

// 폼 유효성 검사
const isFormValid = computed(() => {
  return loginData.value.loginId.trim() !== '' && 
         loginData.value.loginPw.trim() !== '';
});

// store에서 로딩 상태 가져오기
const loading = computed(() => store.getters.loginLoading || isSubmitting.value || isImpersonating.value);

// 스낵바 상태 가져오기
const snackbar = computed(() => store.getters.snackbar);

// 로그인 처리
const handleLogin = async () => {
  if (!isFormValid.value || isSubmitting.value) return;
  
  isSubmitting.value = true;
  
  try {
    const result = await store.dispatch('performLogin', {
      loginId: loginData.value.loginId,
      loginPw: loginData.value.loginPw,
      autoLogin: false // 자동 로그인 기능 제거
    });
    
    if (result.success) {
      // 아이디 저장 처리
      if (saveId.value) {
        localStorage.setItem('savedLoginId', loginData.value.loginId);
      } else {
        localStorage.removeItem('savedLoginId');
      }
      
      // m_role에 따라 분기 처리
      if (store.getters.isAdmin) {
        // Admin인 경우 관리자 회원관리 페이지로 이동
        router.push('/admin/members');
      } else {
        // 일반 사용자인 경우 임금 관리 페이지로 이동
        router.push('/pgm/wage/WageProcess');
      }
    } else {
      // 로그인 실패 시 비밀번호 필드 초기화 및 포커스
      loginData.value.loginPw = '';
      // 다음 틱에서 비밀번호 필드에 포커스
      setTimeout(() => {
        const passwordField = document.querySelector('input[type="password"]') as HTMLInputElement;
        if (passwordField) {
          passwordField.focus();
        }
      }, 100);
    }
  } catch (error: any) {
    console.error('로그인 오류:', error);
    
    // 예외 발생 시에도 비밀번호 필드 초기화
    loginData.value.loginPw = '';
    setTimeout(() => {
      const passwordField = document.querySelector('input[type="password"]') as HTMLInputElement;
      if (passwordField) {
        passwordField.focus();
      }
    }, 100);
  } finally {
    isSubmitting.value = false;
  }
};

// 회원가입 처리
const handleSignup = () => {
  router.push('/pgm/signup');
};

// 대리 로그인 세션 설정
const handleImpersonateLogin = async (token: string) => {
  isImpersonating.value = true;
  
  try {
    // store 액션을 통해 대리 로그인 처리
    const result = await store.dispatch('performImpersonateLogin', token);
    
    if (result.success) {
      // 임금관리 페이지로 이동
      router.push('/pgm/wage/WageProcess');
    } else {
      // 실패 시 로그인 페이지에 머무름 (URL에서 토큰 제거)
      router.replace('/pgm/login');
    }
  } catch (error) {
    console.error('대리 로그인 세션 설정 오류:', error);
    router.replace('/pgm/login');
  } finally {
    isImpersonating.value = false;
  }
};

// 컴포넌트 마운트 시 이미 로그인된 사용자 확인 및 저장된 아이디 불러오기
onMounted(async () => {
  // URL에서 impersonate 토큰 확인 (대리 로그인)
  const impersonateToken = route.query.impersonate as string;
  
  if (impersonateToken) {
    // 대리 로그인 토큰이 있으면 sessionStorage에 저장하고 세션 설정
    // (쿠키는 건드리지 않음 - Admin 세션 유지)
    await handleImpersonateLogin(impersonateToken);
    return;
  }
  
  await store.dispatch('validateAuth');
  if (store.getters.isLoggedIn) {
    // m_role에 따라 분기 처리
    if (store.getters.isAdmin) {
      router.push('/admin/members');
    } else {
      router.push('/pgm/wage/WageProcess');
    }
  } else {
    // 저장된 아이디 불러오기
    const savedLoginId = localStorage.getItem('savedLoginId');
    if (savedLoginId) {
      loginData.value.loginId = savedLoginId;
      saveId.value = true;
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LodingComponent = _resolveComponent("LodingComponent")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LodingComponent, {
      "is-visible": loading.value,
      text: isImpersonating.value ? '대리 로그인 중...' : '로그인 중...'
    }, null, 8, ["is-visible", "text"]),
    _createVNode(_component_v_card, {
      class: "login-card",
      elevation: "8"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "text-center pl-6 pr-6 pt-8 pb-0" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: logoImage.value,
              height: "60",
              width: "auto",
              class: "mb-4 logo-filter"
            }, null, 8, _hoisted_2),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-h4 font-weight-bold" }, "로그인", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis mt-2" }, "재가장기요양센터 관리 시스템", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "pa-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              ref_key: "loginForm",
              ref: loginForm,
              onSubmit: _withModifiers(handleLogin, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: loginData.value.loginId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginData.value.loginId) = $event)),
                  label: "아이디",
                  variant: "outlined",
                  rules: [rules.required],
                  "prepend-inner-icon": "mdi-account",
                  class: "mb-3",
                  disabled: loading.value,
                  clearable: ""
                }, null, 8, ["modelValue", "rules", "disabled"]),
                _createVNode(_component_v_text_field, {
                  modelValue: loginData.value.loginPw,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginData.value.loginPw) = $event)),
                  label: "비밀번호",
                  type: "password",
                  variant: "outlined",
                  rules: [rules.required],
                  "prepend-inner-icon": "mdi-lock",
                  disabled: loading.value,
                  clearable: "",
                  onKeyup: _withKeys(handleLogin, ["enter"])
                }, null, 8, ["modelValue", "rules", "disabled"]),
                _createVNode(_component_v_checkbox, {
                  modelValue: saveId.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((saveId).value = $event)),
                  label: "아이디 저장",
                  color: "primary",
                  disabled: loading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, { class: "pl-6 pr-6 pt-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: handleLogin,
              color: "primary",
              variant: "flat",
              block: "",
              size: "large",
              loading: loading.value,
              disabled: !isFormValid.value || loading.value,
              rounded: "lg"
            }, {
              default: _withCtx(() => [
                (!loading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "로그인"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, "로그인 중..."))
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_card_actions, { class: "pl-6 pr-6 pt-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "text",
              block: "",
              disabled: loading.value,
              "prepend-icon": "mdi-account-plus",
              onClick: handleSignup
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" 회원가입 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: snackbar.value.timeout,
      location: "top"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "white",
          variant: "text",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (snackbar.value.show = false))
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" 닫기 ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.text) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color", "timeout"])
  ]))
}
}

})